import {
    Component, OnInit, Input, OnDestroy,
    AfterViewInit, ChangeDetectionStrategy,
    ChangeDetectorRef, ViewChild, SimpleChanges, OnChanges
} from '@angular/core';
// Animations

import { ActivatedRoute, Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { SelectionModel } from '@angular/cdk/collections';
import * as fromPaymentCheck from '../../../screens/payment-check/state/payment-check.selectors';
import * as PaymentCheckAction from '../../../screens/payment-check/state/payment-check.actions';
import { Store } from '@ngrx/store';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { slideInDownAnimation } from 'src/app/app.animation';
import { FormCCService } from 'src/commons/services/formCC.service';
import { AngularMaterialService } from 'src/commons';

@Component({
    selector: 'payment-check-table-component',
    templateUrl: 'payment-check-table-component.html',
    styleUrls: ['payment-check-table-component.scss'],
    animations: [slideInDownAnimation],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PaymentCheckTableComponent implements OnInit, OnChanges {
    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;
    @Input() data: any[];
    @Input() type: any;
    @Input() displayedColumns: any[];
    // public displayedColumns = ['select', 'requestNo', 'formCCName', 'OrgInfo.name', 'OrgInfo.subsection_501', 'effdt',
    //     'statusDescr', 'validateStatusCode', 'view'];
    selection = new SelectionModel<any>(true, []);
    selectedRequests = [];
    datePipe = new DatePipe('en-US');

    // public displayedColumns = [];
    // public displayedColumns = ['requestNo', 'formCCName', 'OrgInfo.name', 'effdt', 'statusDescr', 'validateStatusCode'];
    public dataSource: MatTableDataSource<any>;
    isAllChecked: boolean = false;
    isIndeterminate: boolean = false;
    localData: any[];

    constructor(
        private store: Store<fromPaymentCheck.State>,
        private ref: ChangeDetectorRef,
        private route: ActivatedRoute,
        private router: Router,
        private ams: AngularMaterialService,
        private formCCService: FormCCService
    ) {
    }
    public ngOnInit() {
        // this.startSubscriptions();
        setTimeout(() => {
            this.localData = this.data;
            // if (this.data !== undefined) {
            //     this.localData.filter(i => i.statusDescr !== 'Approved').map(value => {
            //         switch (value.statusAdmin) {
            //             case 'Negotiable':
            //                 value.statusAdmin = 'Check Issued'
            //                 break;
            //         }
            //     });
            // }
            this.buildDataSource(this.localData);
        });
    }
    buildDataSource(data: any) {
        const filter = this.dataSource !== undefined ? this.dataSource.filter : '';
        this.dataSource = new MatTableDataSource(data);
        this.dataSource.sortingDataAccessor = (item, property) => {
            switch (property) {
                case 'OrgInfo.name': return data.OrgInfo.name.toLowerCase();
                case 'OrgInfo.subsection_501': return isNaN(item.orgInfoSubsection) ? item.orgInfoSubsection : +item.orgInfoSubsection;
                case 'FormCCOeBS.validateStatusCode': return item.FormCCOeBS.validateStatusCode.toLowerCase();
                case 'effdt': return this.datePipe.transform(item.effdt, 'MM-dd-yyyy');
                default: return item[property];
            }
        };
        this.dataSource.filterPredicate = (data, filter: string) => {
            const accumulator = (currentTerm, key) => {
                switch (key) {
                    case 'OrgInfo':
                        return currentTerm + data.OrgInfo.name + this.getTaxExemptStatus(data.OrgInfo.subsection_501);
                    case 'FormCCLogInfo':
                        return currentTerm
                            + data.FormCCLogInfo.empName
                            + data.FormCCLogInfo.title
                            + data.FormCCLogInfo.comment;
                    case 'effdt':
                        const newDate = this.datePipe.transform(data.effdt, 'MM-dd-yyyy');
                        return currentTerm + newDate.toString();
                    default:
                        return currentTerm + data[key];
                }
            };
            const dataStr = Object.keys(data).reduce(accumulator, '').toLowerCase();
            const transformedFilter = filter.trim().toLowerCase();
            return dataStr.includes(transformedFilter);
        };
        this.dataSource.filter = filter;
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.clearToggle();
    }

    public ngOnChanges(changes: SimpleChanges) {
        console.log(changes);
        if (changes['data']) {
            setTimeout(() => {
                this.localData = changes['data'].currentValue;
                this.buildDataSource(this.localData);
                this.selection.clear();
            });
        }
    }

    onValidate() {
        this.ams.showConfirm('Are you sure you want to validate selected request(s)?', '');
        this.ams.confirm.afterClosed().subscribe(result => {
            if (result === 'yes') {
                this.store.dispatch(new PaymentCheckAction.ValidateFormCC(this.selection.selected))
            }
        });
    }

    uploadToOeBS() {
        this.ams.showConfirm('Are you sure you want to send selected request(s) to OeBS?', '');
        this.ams.confirm.afterClosed().subscribe(result => {
            if (result === 'yes') {
                this.store.dispatch(new PaymentCheckAction.SendToOeBSFormCC(this.selection.selected))
            }
        });
    }

    generateCR() {
        this.store.dispatch(new PaymentCheckAction.LoadFormCCForControlReportState());
    }


    isAllSelected() {
        let isAll = false;
        isAll = this.data.length === this.selection.selected.length;
        this.isAllChecked = this.selection.hasValue() && isAll;
        this.isIndeterminate = this.selection.hasValue() && !isAll;
    }

    /** Selects all rows if they are not all selected; otherwise clear selection. */
    masterToggle(event) {
        if (this.isAllChecked) {
            this.clearToggle();
        } else {
            this.dataSource.filteredData.forEach(row => this.selection.select(row));
        }
        this.isAllSelected();
        // this.selectedRequests = isChecked ? this.dataSource.data.map(obj => ({ ...obj })) : [];
        // this.isShowVAlidate = this.selectedRequests.length === 0 ? false : true;
    }

    formDataChecked(row) {
        this.selection.toggle(row);
        this.isAllSelected();
    }

    clearToggle() {
        this.selection.clear();
        this.isAllSelected();
    }

    // formCCDataChecked(row) {
    //     this.selection.toggle(row);
    //     if (this.selectedFormCCData.find(formCCData => row.formccId === formCCData.formccId)) {
    //         const index = this.selectedFormCCData.findIndex(formCCData => row.formccId === formCCData.formccId);
    //         this.selectedFormCCData.splice(index, 1);
    //     } else {
    //         this.selectedFormCCData.push(row);
    //     }
    //     this.isShowVAlidate = this.selectedFormCCData.length === 0 ? false : true;
    // }
    public getStatusClass(status): string {
        const possibleStatus = ['Submitted', 'Pending', 'Draft', 'Approved', 'PendingApproval', 'Rejected', 'INVALID', 'VALID', 'SUCCESSFUL', 'Sent To Oracle', 'Waiting For Oracle', 'Withdrawn', 'Paid Credit', 'Check Cashed', 'Check Issued', 'Check Voided'];
        return possibleStatus.indexOf(status) > -1 && status.toLowerCase();
    }

    public selectRow(row): void {
        this.formCCService.setIsAdminReadOnly(row.formccId);
        this.router.navigate([`charity-forms/charitable-contribution/${row.formccId}`]);
    }
    getTaxExemptStatus(value) {
        if (value === '')
            return 'Other';
        else if (isNaN(value) || +value === 0) {
            return value;
        } else {
            return `501(c)(${+value})`;
        }
    }
    public applyFilter(filterValue: string) {
        filterValue = filterValue.trim();
        filterValue = filterValue.toLowerCase();
        this.dataSource.filter = filterValue;
    }


}
